import React, { useState } from "react";
import axios from "axios";
import "./Login.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "/v1";

interface LoginProps {
  onLogin: (userId: string, username: string, permissions?: string[]) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [accessCode, setAccessCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${accessCode}` },
      });

      const { id, username, permissions } = response.data;

      // Check if user has solution permissions
      const hasSolutionPermissions = permissions.some((perm: string) =>
        perm.startsWith("upload_solutions_")
      );

      if (!hasSolutionPermissions) {
        setError("You don't have permission to access the solution platform.");
        return;
      }

      // Store authentication data
      localStorage.setItem("userId", id);
      localStorage.setItem("username", username);
      localStorage.setItem("accessCode", accessCode);
      localStorage.setItem("userPermissions", JSON.stringify(permissions));

      onLogin(id, username, permissions);
    } catch (err: any) {
      console.error("Login error:", err);
      if (err.response?.status === 401) {
        setError("Invalid access code. Please try again.");
      } else {
        setError("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h1>Login</h1>
        <p>Enter your access code to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
            placeholder="Access Code"
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading || !accessCode.trim()}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default Login;